import { BASE_URL_API } from "../../../constants";
import fetcher from "../../../utils/fetcher";

export const _preonboarding = async () => {
    // const { id: id_user } = useAuthDetailStore.getState().detail;
    return fetcher(`${BASE_URL_API}/preonboarding`, {
        method: "GET",
        credentials: "include",
    });
};

export const _submitFactsheet = async () => {
    return fetcher(`${BASE_URL_API}/user/${333}/profile/identity/form`, {
        method: "POST",
        credentials: "include",
        body: JSON.stringify({
            personal_infos: {
                birth_name: "EL Yans",
                address: {
                    street: "12 rue de la Paix",
                    postal_code: "75001",
                    city: "Paris",
                    country: "FR",
                },
                nationality: "FR",
                working_permit: "D",
                birthdate: "1990-05-15",
                place_of_birth: "Lyon",
                country_of_birth: "FR",
                diploma: "Master",
                health_insurance: "CPAM",
                identity_card_type: 1,
                identity_card_number: "123456789",
                identity_card_expiry_date: "2030-12-31",
                avs: "",
                marital_status: 2,
                couple_registration_date: null,
            },
            partner: {
                full_name: "bens",
                birthdate: "1990-01-01",
                marriage_date: "2020-01-01",
                working_country: "FR",
                work_start_date: "2022-01-01",
                work_end_date: null,
                working_permit: "-",
                working_type: 0,
            },
            children: [
                {
                    first_name: "Yanis",
                    last_name: "Bens",
                    birthdate: "2023-01-01",
                    relationship: "parent",
                    address: "sfdsdfsdf",
                    parental_authority: "pere",
                },
            ],
            bank_account: {
                bank_name: "Ma Banque",
                iban: "CH93 0076 2011 6238 5295 7",
            },
            emergency_contacts: [
                {
                    full_name: "Jean Dupont",
                    phone_number: "0612345678",
                    email: "jean.dupont@example.com",
                    relationship: "Père",
                },
            ],
        }),
    });
};
